<!-- Standalone header (no hamburger) -->
<header class="cart-page-header">
  <nav class="navbar container-fluid">
    <div class="brand">
      <a routerLink="/" class="brand-link">
        <img src="assets/images/Veeduplan logo.png" alt="VeeduPlan Logo" class="logo">
      </a>
    </div>
  </nav>
</header>

<!-- Page banner (base color) -->
<section class="cart-banner">
  <div class="container banner-grid">
    <div>
      <h1 class="banner-title">Shopping Cart <span class="item-count-badge">({{itemCount}})</span></h1>
      <p class="banner-subtitle">Review and download your selected templates.</p>
    </div>
    <div class="banner-actions">
      <button class="back-button" type="button" (click)="goBack()">
        ← Back
      </button>
      <button class="home-button" type="button" routerLink="/home">
        Home
      </button>
    </div>
  </div>
</section>

<section class="cart-page container py-5">

  <div *ngIf="items.length === 0" class="empty">
    <p>No templates in your cart.</p>
    <button class="secondary" routerLink="/viewalltemplate">Browse templates</button>
  </div>

  <div *ngIf="items.length > 0" class="cart-container">
    <!-- Main Cart Items Section -->
    <div class="cart-items-section">
      <div class="cart-items">
        <div class="cart-item" *ngFor="let item of items">
          <img [src]="item.image" [alt]="item.title">
          <div class="info">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
            <div class="item-price">₹{{ item.price }}</div>
            <button class="remove" (click)="remove(item.id)">Remove</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Pricing Sidebar -->
    <div class="cart-sidebar">
      <div class="price-summary">
        <h3>Price Details</h3>
        <div class="price-breakdown">
          <div class="price-row d-none">
            <span class="price-label">Price per template</span>
            <span class="price-value">₹{{ totalPrice }}</span>
          </div>
          <div class="price-row">
            <span class="price-label">Template Count</span>
            <span class="price-value">{{ itemCount }}</span>
          </div>
          <div class="price-row total-row">
            <span class="price-label">Total Amount</span>
            <span class="price-value total-amount">₹{{ totalPrice }}</span>
          </div>
        </div>
        <button class="download-all" (click)="downloadAll()">Download All Templates</button>
      </div>
    </div>
  </div>
</section>

